import { ComponentType } from "react"
import { FlyingCarpetPage } from "./flying-carpet.store"
import { CartPanel } from "./screens/CartPanel"
import { SignInPanel } from "./screens/SignInPanel"
import { AccountPanel } from "./screens/AccountPanel"

export type FlyingCarpetPageDefinition = {
  component: ComponentType
  getInfo?: () => {
    label: string
  }
}

export const FLYING_CARPET_PAGES: Record<FlyingCarpetPage, FlyingCarpetPageDefinition> = {
  cart: {
    component: CartPanel,
    getInfo: () => ({
      label: "Your Cart",
    }),
  },
  account: {
    component: AccountPanel,
    getInfo: () => ({
      label: "Your Account",
    }),
  },
  forgotpassword: {
    component: () => {
      return <div>Forgot Password</div>
    },
    getInfo: () => ({
      label: "Forgot Password",
    }),
  },
  other: {
    component: () => {
      return <div>Other</div>
    },
  },
  signin: {
    component: SignInPanel,
    getInfo: () => ({
      label: "Sign In",
    }),
  },
  signup: {
    component: () => {
      return <div>Sign Up</div>
    },
    getInfo: () => ({
      label: "Create an Account",
    }),
  },
}
